module.exports = __webpack_public_path__ + "static/media/money-check-alt.f538e6fb.svg";